$(document).ready(function() {
    $(document).on('DOMSubtreeModified', '.product-block.product-block--price .regular_price_con span.product__price', function() {
        var price = $(this).text();
        let floatValue = parseFloat(price.replace('$', ''));
        let newprice = floatValue * 0.9;
        $('span.subscription_regular.product__price').text(`$${newprice.toFixed(2)}`)
    });

    $(document).on('click', '.MPDPSticky_typePopupContainer', function() {
        $('.MPDPStickyCTA_typePopUpValues').toggleClass('active_sticky_values')
        $('.sticky_subscription_values').removeClass('active_sticky_values')
    })
    $(document).on('click', '.sticky_subscription_selected', function() {
        $('.sticky_subscription_values').toggleClass('active_sticky_values')
        $('.MPDPStickyCTA_typePopUpValues').removeClass('active_sticky_values')
    })
    $(document).on('click', function(event) {
        let container = $('.MPDPSticky_typecontainer');
        if (!container.is(event.target) && container.has(event.target).length == 0) {
            $('.MPDPStickyCTA_typePopUpValues').removeClass('active_sticky_values')
        }
        let container1 = $('.sticky_subscription_');
        if (!container1.is(event.target) && container1.has(event.target).length == 0) {
            $('.sticky_subscription_values').removeClass('active_sticky_values')
        }
    });

    $(document).on('click', '.section_founder_testimonial .desc_collapse svg', function() {
        $('.section_founder_testimonial .founder_desc p').toggleClass('block')
        $(this).toggleClass('icon_rotate')
    })
})

$(document).ready(function() {
    let currenturl = window.location.href
    if(currenturl.includes('collections/') && !currenturl.includes('/products/')) {
        let parent = $(".Collections_image_filters-wrapper").width();
        let child =  document.querySelector(".Collections_image_filters-wrapper").scrollWidth;

        if(parent < child -10) {
            $('#Collections_image_filters .Collections_image_filters-wrapper.Collections_image_filters-center').removeClass('Collections_image_filters-center')
            $('button#Collections_image_filters-arrow-left').addClass('Collections_image_filter_show')
        }

        $(document).on('click', 'button#Collections_image_filters-arrow-left', function(){
            const scrollAmount = 100; // Adjust the scroll amount as needed
            $('#Collections_image_filters .Collections_image_filters-wrapper').scrollLeft($('#Collections_image_filters .Collections_image_filters-wrapper').scrollLeft() + 100)
            $('button#Collections_image_filters-arrow-right').addClass('Collections_image_filter_show')
        })

        $(document).on('click', 'button#Collections_image_filters-arrow-right', function(){
            const scrollAmount = 100; // Adjust the scroll amount as needed
            $('#Collections_image_filters .Collections_image_filters-wrapper').scrollLeft($('#Collections_image_filters .Collections_image_filters-wrapper').scrollLeft()-100);
        })
    }
})

$(document).ready(function() {
    $(window).resize(function(){
        let currenturl = window.location.href
        if(currenturl.includes('collections/') && !currenturl.includes('/products/')) {
            let parent = $(".Collections_image_filters-wrapper").width();
            let child =  document.querySelector(".Collections_image_filters-wrapper").scrollWidth;
            if(parent < (child -10) ) {
                $('#Collections_image_filters .Collections_image_filters-wrapper.Collections_image_filters-center').removeClass('Collections_image_filters-center')
                $('button#Collections_image_filters-arrow-left').addClass('Collections_image_filter_show')
            } else {
                $('#Collections_image_filters .Collections_image_filters-wrapper').addClass('Collections_image_filters-center')
                $('button#Collections_image_filters-arrow-left').removeClass('Collections_image_filter_show')
                $('button#Collections_image_filters-arrow-right').removeClass('Collections_image_filter_show')
            }
        
            $(document).on('click', 'button#Collections_image_filters-arrow-left', function(){
                const scrollAmount = 100; // Adjust the scroll amount as needed
                $('#Collections_image_filters .Collections_image_filters-wrapper').scrollLeft($('#Collections_image_filters .Collections_image_filters-wrapper').scrollLeft() + 100)
                $('button#Collections_image_filters-arrow-right').addClass('Collections_image_filter_show')
            })
        
            $(document).on('click', 'button#Collections_image_filters-arrow-right', function(){
                const scrollAmount = 100; // Adjust the scroll amount as needed
                $('#Collections_image_filters .Collections_image_filters-wrapper').scrollLeft($('#Collections_image_filters .Collections_image_filters-wrapper').scrollLeft()-100);
            })
        }
    })
})

$(document).ready(function() {
    $(document).on('click', '.Collections_image_filters-wrapper label.Collections_image_filter input', function() {
        let value = $(this).val()
        let parent = $(this)
        let types = []

        let url = window.location.href
        let param = url.split('?filter=')[1]
        
        if($(this).is(":checked")) {
            let refresh
            if(param) {
                refresh = window.location.href + `+${value}`;    
            } else {
                refresh = window.location.href + `?filter=${value}`; 
            }
            window.history.pushState({ path: refresh }, '', refresh);
        } else {
            if(param) {
                let refresh
                if (url.includes(`+${value}`)) {
                    refresh = url.replace(`+${value}`, "");
                } else if(url.includes(`${value}+`)){
                    refresh = url.replace(`${value}+`, "");
                } else {
                    refresh = url.replace(`?filter=${value}`, "");
                }
                window.history.pushState({ path: refresh }, '', refresh);
            }
            
        }
        $('.Collections_image_filters-wrapper label.Collections_image_filter input[type="checkbox"]:checked').each(function() {
            types.push($(this).val());
        });

        if(types.length == 0) {
            $('div#CollectionAjaxContent .grid.grid--uniform > div').removeClass('remove')
             $('#Collections_image_filters_no-products').addClass('remove')
        } else {
            $('div#CollectionAjaxContent .grid.grid--uniform > div').each(function(index, element) {
                const title = element.querySelector(".grid-product__meta .grid-product__title");
                const vendor = element.querySelector(".grid-product__meta .grid-product__vendor:not(.caffeine_level)");
                const level = element.querySelector(".grid-product__vendor.caffeine_level")
                const accessories = $(this).attr('data-type')
                const type = types.filter(type => {
                    const regex = new RegExp("\\b" + type + "\\b", "i");
                    return regex.test(vendor?.innerHTML || "") || regex.test(accessories || "") || regex.test(title?.innerHTML || "") || regex.test(level?.innerHTML || "");
                });
                
                if (type.length>0) {
                    $(this).removeClass('remove')
                } else {
                    $(this).addClass('remove')
                }
            })

            let items = $('div#CollectionAjaxContent .grid.grid--uniform > div:not(.remove)');
            if(items.length == 0) {
                $('#Collections_image_filters_no-products').removeClass('remove')
            } else {
                $('#Collections_image_filters_no-products').addClass('remove')
            }
        }
    })
})
$(document).ready(function() {
    $(document).on('click', '.PDP_ImproveDes_tabs .PDP_ImproveDes_tab', function() {
        $('.PDP_ImproveDes_tabs .PDP_ImproveDes_tab').removeClass('PDP_ImproveDes_selected')
        $(this).addClass('PDP_ImproveDes_selected')
        let tab_type = $(this).attr('tap-type')

        $('.PDP_ImproveDes_content').addClass('remove')
        $(`.PDP_ImproveDes_content.${tab_type}`).removeClass('remove')
    })
})

$( document ).ready(function() {
    let url = window.location.href
    if(url.includes("/collections/tea") ||  url.includes("/collections/coffee")) {
        let filter = url.split('?filter=')[1]
        if (filter) {
            let items = filter.split('+')
            if(items.length){
                $('.Collections_image_filters-wrapper label.Collections_image_filter input[type="checkbox"]').each(function() {
                    if(items.includes($(this).val())){
                        console.log($(this).val())
                        $(this).prop('checked', true);
                    }
                });

                $('div#CollectionAjaxContent .grid.grid--uniform > div').each(function(index, element) {
                    const title = element.querySelector(".grid-product__meta .grid-product__title");
                    const vendor = element.querySelector(".grid-product__meta .grid-product__vendor:not(.caffeine_level)");
                    const level = element.querySelector(".grid-product__vendor.caffeine_level")
                    const accessories = $(this).attr('data-type')
                    const type = items.filter(type => {
                        const regex = new RegExp("\\b" + type + "\\b", "i");
                        return regex.test(vendor?.innerHTML || "") || regex.test(accessories || "") || regex.test(title?.innerHTML || "") || regex.test(level?.innerHTML || "");
                    });
                    
                    if (type.length>0) {
                        $(this).removeClass('remove')
                    } else {
                        $(this).addClass('remove')
                    }
                })
                let avialableitems = $('div#CollectionAjaxContent .grid.grid--uniform > div:not(.remove)');
                if(avialableitems.length == 0) {
                    $('#Collections_image_filters_no-products').removeClass('remove')
                } else {
                    $('#Collections_image_filters_no-products').addClass('remove')
                }
            }
        }
    }
})

$(document).ready(function() {
    var currentPath = window.location.pathname;
    if (currentPath === '/') {
        let parent = $("div#RHPShowcasePDP_mainContainer").width();
        let child =  document.querySelector(".RHPShowcasePDP_itemsDiv").scrollWidth;

        if(parent < child) {
            $('.RHPShowcasePDP_arrows').removeClass('remove')
        }
        if(document.querySelector(".RHPShowcasePDP_itemsDiv").scrollLeft < 10) {
            $('.RHPShowcasePDP_arrows span.__left__').addClass('arrow_opacity')
            $('.RHPShowcasePDP_arrows span.__right__').removeClass('arrow_opacity')
        } else {
            $('.RHPShowcasePDP_arrows span.__left__').removeClass('arrow_opacity')
        }
        $(document).on('click', '.RHPShowcasePDP_arrows span.__right__', function(){
            let scrollAmount = 200
            if (window.innerWidth < 1000) {
                scrollAmount = 100
            }
            $('.RHPShowcasePDP_itemsDiv').scrollLeft($('.RHPShowcasePDP_itemsDiv').scrollLeft() + scrollAmount)
            if(document.querySelector(".RHPShowcasePDP_itemsDiv").scrollLeft + document.querySelector(".RHPShowcasePDP_itemsDiv").clientWidth >= document.querySelector(".RHPShowcasePDP_itemsDiv").scrollWidth) {
                $('.RHPShowcasePDP_arrows span.__right__').addClass('arrow_opacity')
            } 
            $('.RHPShowcasePDP_arrows span.__left__').removeClass('arrow_opacity')
        })
    
        $(document).on('click', '.RHPShowcasePDP_arrows span.__left__', function(){
            let scrollAmount = 200
            if (window.innerWidth < 1000) {
                scrollAmount = 100
            }
            $('.RHPShowcasePDP_itemsDiv').scrollLeft($('.RHPShowcasePDP_itemsDiv').scrollLeft() - scrollAmount)

            if(document.querySelector(".RHPShowcasePDP_itemsDiv").scrollLeft < 10) {
                $('.RHPShowcasePDP_arrows span.__left__').addClass('arrow_opacity')
            } 
            $('.RHPShowcasePDP_arrows span.__right__').removeClass('arrow_opacity')
        })
        $('.RHPShowcasePDP_itemsDiv').on('scroll', function() {
            if(document.querySelector(".RHPShowcasePDP_itemsDiv").scrollLeft + document.querySelector(".RHPShowcasePDP_itemsDiv").clientWidth >= document.querySelector(".RHPShowcasePDP_itemsDiv").scrollWidth) {
                $('.RHPShowcasePDP_arrows span.__right__').addClass('arrow_opacity')
            } else {
                $('.RHPShowcasePDP_arrows span.__right__').removeClass('arrow_opacity')
            }
            if(document.querySelector(".RHPShowcasePDP_itemsDiv").scrollLeft < 10) {
                $('.RHPShowcasePDP_arrows span.__left__').addClass('arrow_opacity')
            } else {
                $('.RHPShowcasePDP_arrows span.__left__').removeClass('arrow_opacity')
            }
        })
    }
})

$(document).ready(function() {
    $(window).resize(function(){
        var currentPath = window.location.pathname;
        if (currentPath === '/') {
            let parent = $("div#RHPShowcasePDP_mainContainer").width();
            let child =  document.querySelector(".RHPShowcasePDP_itemsDiv").scrollWidth;
    
            if(parent < child) {
                $('.RHPShowcasePDP_arrows').removeClass('remove')
            } else{
                $('.RHPShowcasePDP_arrows').addClass('remove')
            }
        
        
            $(document).on('click', '.RHPShowcasePDP_arrows span.__right__', function(){
                let scrollAmount = 200
                if (window.innerWidth < 1000) {
                    scrollAmount = 100
                }
                $('.RHPShowcasePDP_itemsDiv').scrollLeft($('.RHPShowcasePDP_itemsDiv').scrollLeft() + scrollAmount)
                if(document.querySelector(".RHPShowcasePDP_itemsDiv").scrollLeft + document.querySelector(".RHPShowcasePDP_itemsDiv").clientWidth >= document.querySelector(".RHPShowcasePDP_itemsDiv").scrollWidth) {
                    $('.RHPShowcasePDP_arrows span.__right__').addClass('arrow_opacity')
                } 
                $('.RHPShowcasePDP_arrows span.__left__').removeClass('arrow_opacity')
            })
        
            $(document).on('click', '.RHPShowcasePDP_arrows span.__left__', function(){
                let scrollAmount = 200
                if (window.innerWidth < 1000) {
                    scrollAmount = 100
                }
                $('.RHPShowcasePDP_itemsDiv').scrollLeft($('.RHPShowcasePDP_itemsDiv').scrollLeft() - scrollAmount)
                if(document.querySelector(".RHPShowcasePDP_itemsDiv").scrollLeft <10) {
                    $('.RHPShowcasePDP_arrows span.__left__').addClass('arrow_opacity')
                } 
                $('.RHPShowcasePDP_arrows span.__right__').removeClass('arrow_opacity')
            })

            $('.RHPShowcasePDP_itemsDiv').on('scroll', function() {
                if(document.querySelector(".RHPShowcasePDP_itemsDiv").scrollLeft + document.querySelector(".RHPShowcasePDP_itemsDiv").clientWidth >= document.querySelector(".RHPShowcasePDP_itemsDiv").scrollWidth) {
                    $('.RHPShowcasePDP_arrows span.__right__').addClass('arrow_opacity')
                } else {
                    $('.RHPShowcasePDP_arrows span.__right__').removeClass('arrow_opacity')
                }
                if(document.querySelector(".RHPShowcasePDP_itemsDiv").scrollLeft < 10) {
                    $('.RHPShowcasePDP_arrows span.__left__').addClass('arrow_opacity')
                } else {
                    $('.RHPShowcasePDP_arrows span.__left__').removeClass('arrow_opacity')
                }
            })
        }
    })
})

$(document).ready(function() {
    let url = window.location.pathname
    if(url.includes('/products/') && $(window).width() < 590) {
        $(window).scroll(function(){
            const triggerElement = $('div.payment_block');
            if(triggerElement) {
                function handleIntersection(entries, observer) {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            $('.sticky_cart_price').addClass('remove')
                            $('.sticky_atc_widget').addClass('remove')
                            $('.payment-buttons').removeClass('cart_sticky_btn')
                        } else {
                            $('.sticky_cart_price').removeClass('remove')
                            $('.sticky_atc_widget').removeClass('remove')
                            $('.payment-buttons').addClass('cart_sticky_btn')
                        }
                    });
                }
                const observer = new IntersectionObserver(handleIntersection, { threshold: 0 });
                observer.observe(triggerElement[0]);
            }
        })
    }

    $(window).resize(function(){
        if(url.includes('/products/') && $(window).width() < 590) {
            const triggerElement = $('div.payment_block');
            if(triggerElement) {
                function handleIntersection(entries, observer) {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            $('.sticky_cart_price').addClass('remove')
                            $('.sticky_atc_widget').addClass('remove')
                            $('.payment-buttons').removeClass('cart_sticky_btn')
                        } else {
                            $('.sticky_cart_price').removeClass('remove')
                            $('.sticky_atc_widget').removeClass('remove')
                            $('.payment-buttons').addClass('cart_sticky_btn')
                        }
                    });
                }
                const observer = new IntersectionObserver(handleIntersection, { threshold: 0 });
                observer.observe(triggerElement[0]);
            }
        }
    })
})

$(document).ready( function() {
    $(document).on('change', '.rc-selling-plans-dropdown__select', function() {
        let selected_id = $(this).val();
        $('.sticky_subscription_values .selling_option').removeClass('selected');
        $(`.sticky_subscription_values .selling_option[data-id="${selected_id}"]`).addClass('selected');
        let name = $(`.sticky_subscription_values .selling_option[data-id="${selected_id}"] span:last-child`).text();
        $('span.sticky_value_selected').attr('data-id', selected_id);
        $('span.sticky_value_selected').text(name)
    })

    $(document).on('click', 'label.rc-radio.onetime-radio input#rc-radio2', function() {
        if($(this).is(":checked")) {
            $('.sticky_subscription_values .selling_option').removeClass('selected');
            $(`.sticky_subscription_values .selling_option[data-id="onetime"]`).addClass('selected');
            $('span.sticky_value_selected').attr('data-id', 'onetime');
            $('span.sticky_value_selected').text('One-time only')
            let price = $('.rc-radio.onetime-radio span.rc-radio__label').text()
            $('span.sticky_cart_price').text(` | $${price.split('$')[1]}`)
            let checked_cup_number = $('.variant-input-wrap input[type=radio]:checked+label.p_Clarity_label .P_Clarity_byCupText')
            if (checked_cup_number.length) {
                let checked_cup_price = $('.variant-input-wrap input[type=radio]:checked+label.p_Clarity_label').attr('data-price')
                let unchcked_cup_number = $('.variant-input-wrap input[type=radio]:not(:checked)+label.p_Clarity_label .P_Clarity_byCupText')
                let unchecked_cup_price = $('.variant-input-wrap input[type=radio]:not(:checked)+label.p_Clarity_label').attr('data-price')

                let checked_per_cup = parseFloat(checked_cup_price) / parseFloat(checked_cup_number.text())
                checked_per_cup = Math.round(checked_per_cup * 100) / 100;
                let unchecked_per_cup = parseFloat(unchecked_cup_price) / parseFloat(unchcked_cup_number.text())
                unchecked_per_cup = Math.round(unchecked_per_cup * 100) / 100;

                if(checked_per_cup) {
                    $('.variant-input-wrap input[type=radio]:checked+label.p_Clarity_label span.p_Clarity_price span').text(`$${checked_per_cup.toFixed(2)}`)
                }
                if(unchecked_per_cup) {
                    $('.variant-input-wrap input[type=radio]:not(:checked)+label.p_Clarity_label span.p_Clarity_price span').text(`$${unchecked_per_cup.toFixed(2)}`)
                }
                if(checked_per_cup && unchecked_per_cup){
                    if(checked_per_cup>unchecked_per_cup) {
                        let saving = (checked_per_cup.toFixed(2) - unchecked_per_cup.toFixed(2))/checked_per_cup.toFixed(2)
                        $('.variant-input-wrap input[type=radio]:not(:checked)+label.p_Clarity_label span.p_Clarity_saving').text(`Save ${(saving * 100).toFixed(0)}%`)
                    }else {
                        let saving = (unchecked_per_cup.toFixed(2) - checked_per_cup.toFixed(2))/unchecked_per_cup.toFixed(2)
                        $('.variant-input-wrap input[type=radio]:checked+label.p_Clarity_label span.p_Clarity_saving').text(`Save ${(saving * 100).toFixed(0)}%`)
                    }
                }
            }
        }
    })

    $(document).on('click', 'label.rc-radio.subscription-radio input#rc-radio1', function() {
        if($(this).is(":checked")) {
            let checked_cup_number = $('.variant-input-wrap input[type=radio]:checked+label.p_Clarity_label .P_Clarity_byCupText')
            if (checked_cup_number.length) {
                let checked_cup_price = $('.variant-input-wrap input[type=radio]:checked+label.p_Clarity_label').attr('data-price')
                let unchcked_cup_number = $('.variant-input-wrap input[type=radio]:not(:checked)+label.p_Clarity_label .P_Clarity_byCupText')
                let unchecked_cup_price = $('.variant-input-wrap input[type=radio]:not(:checked)+label.p_Clarity_label').attr('data-price')

                let checked_per_cup = parseFloat(checked_cup_price) * 0.9 / parseFloat(checked_cup_number.text())
                checked_per_cup = Math.round(checked_per_cup * 100) / 100;
                let unchecked_per_cup = parseFloat(unchecked_cup_price) * 0.9 / parseFloat(unchcked_cup_number.text())
                unchecked_per_cup = Math.round(unchecked_per_cup * 100) / 100;
                if(checked_per_cup) {
                    $('.variant-input-wrap input[type=radio]:checked+label.p_Clarity_label span.p_Clarity_price span').text(`$${checked_per_cup.toFixed(2)}`)
                }
                if(unchecked_per_cup) {
                    $('.variant-input-wrap input[type=radio]:not(:checked)+label.p_Clarity_label span.p_Clarity_price span').text(`$${unchecked_per_cup.toFixed(2)}`)
                }
                if(checked_per_cup && unchecked_per_cup){
                    if(checked_per_cup>unchecked_per_cup) {
                        let saving = (checked_per_cup.toFixed(2) - unchecked_per_cup.toFixed(2))/checked_per_cup.toFixed(2)
                        $('.variant-input-wrap input[type=radio]:not(:checked)+label.p_Clarity_label span.p_Clarity_saving').text(`Save ${(saving * 100).toFixed(0)}%`)
                    }else {
                        let saving = (unchecked_per_cup.toFixed(2) - checked_per_cup.toFixed(2))/unchecked_per_cup.toFixed(2)
                        $('.variant-input-wrap input[type=radio]:checked+label.p_Clarity_label span.p_Clarity_saving').text(`Save ${(saving * 100).toFixed(0)}%`)
                    }
                }
            }
            setTimeout(function() {
                let url = window.location.href
                let selling_id = url.split('selling_plan=')[1]
                $('.sticky_subscription_values .selling_option').removeClass('selected');
                $(`.sticky_subscription_values .selling_option[data-id="${selling_id}"]`).addClass('selected');
                let name = $(`.sticky_subscription_values .selling_option[data-id="${selling_id}"] span:last-child`).text();
                $('span.sticky_value_selected').attr('data-id', selling_id);
                $('span.sticky_value_selected').text(name)
                let price = $('.rc-radio span.rc-radio__price').text()
                $('span.sticky_cart_price').text(` | $${price.split('$')[1]}`)
            }, 500);
        }
    })
})